import React, { useState, useEffect, useRef } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { NavLink } from 'react-router-dom'
import './TopBar.css'

import LogoLeft from '../assets/TopLogoLeft.png'
import LogoRight from '../assets/TopLogoRight.png'

import H from '../assets/Hamburger.svg'
import L from '../assets/Logo.svg'

import Hamburger from '../components/Hamburger'


import { useGSAP } from "@gsap/react";
import gsap from "gsap";


import { useTranslation } from 'react-i18next';

function useIsRootPath() {
  const location = useLocation();
  return location.pathname === '/';
}

const TopBar = () => {

  
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const currentLanguage = i18n.language;
  const getClassName = ({ isActive }) => isActive ? "TopBar-left-element active" : "TopBar-left-element";

  const [deviceWidth, setDeviceWidth] = useState(window.screen.width);
  const isRoot = useIsRootPath();
  // const style = isRoot ? {} : { position: 'absolute', position: 'static' };

  useEffect(() => {
    const handleResize = () => {
      setDeviceWidth(window.screen.width);
    };
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  //hover underline
  const textRef = useRef(null); // Ref for the text container
  const underlineRef = useRef(null); // Ref for the underline element
  const containerRef = useRef(null);

  useGSAP(() => {
    if (containerRef.current) {
      const textElements = containerRef.current.querySelectorAll('.TopBar-left-element');

      textElements.forEach((textElement) => {
        const underline = textElement.querySelector('span');
        // Ensure the underline is initially hidden
        gsap.set(underline, { scaleX: 0, transformOrigin: "left" });

        // Timeline for hover enter
        const tlEnter = gsap.timeline({ paused: true })
          .to(underline, {
            scaleX: 1,
            transformOrigin: "left",
            duration: 0.5,
            ease: "sine.inOut"
          });

        // Timeline for hover leave
        const tlLeave = gsap.timeline({ paused: true })
          .to(underline, {
            scaleX: 0,
            transformOrigin: "right",
            duration: 0.5,
            ease: "sine.inOut"
          });

        // Function to handle mouse enter
        function mouseEnterHandler() {
          if (tlLeave.isActive()) {
            tlLeave.pause();  // Ensure to pause leave timeline if it's active
          }
          tlEnter.restart();
        };

        // Function to handle mouse leave
        function mouseLeaveHandler() {
          if (tlEnter.isActive()) {
            tlEnter.pause();  // Ensure to pause enter timeline if it's active
          }
          tlLeave.restart();
        };

        textElement.addEventListener('mouseenter', mouseEnterHandler);
        textElement.addEventListener('mouseleave', mouseLeaveHandler);

        // Cleanup function needs to be able to access these handlers
        return () => {
          textElement.removeEventListener('mouseenter', mouseEnterHandler);
          textElement.removeEventListener('mouseleave', mouseLeaveHandler);
          tlEnter.kill();
          tlLeave.kill();
        };
      });
    }
  }, []);




  //hamburger
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  //hover menu

  const [isHovering1, setIsHovering1] = useState(false);
  const [isHovering2, setIsHovering2] = useState(false);

  const timeoutRef1 = useRef();
  const timeoutRef2 = useRef();

  const handleMouseEnter1 = () => {
    if (timeoutRef1.current) {
      clearTimeout(timeoutRef1.current);
    }
    setIsHovering1(true);
  };

  const handleMouseLeave1 = () => {
    timeoutRef1.current = setTimeout(() => {
      setIsHovering1(false);
    }, 100); // Delay in milliseconds
  };

  const handleMouseEnter2 = () => {
    if (timeoutRef2.current) {
      clearTimeout(timeoutRef2.current);
    }
    setIsHovering2(true);
  };

  const handleMouseLeave2 = () => {
    timeoutRef2.current = setTimeout(() => {
      setIsHovering2(false);
    }, 100); // Delay in milliseconds
  };

  const [langEN, setLang]=useState(i18n.language === 'en')
  const AZRef = useRef();
  const ENGRef = useRef();

  useEffect(() => {
      // Animate Local text color
      gsap.to(AZRef.current, {
          color: langEN ? '#A2A2A2' : '#000',  
          duration: 0.5,
          ease: 'power1.out',
      });

      // Animate Global text color
      gsap.to(ENGRef.current, {
          color: langEN ? '#000' : '#A2A2A2', 
          duration: 0.5,
          ease: 'power1.out',
      });
  }, [langEN]);

  useEffect(() => {
    const handleLanguageChange = (lng) => {
      setLang(lng === 'en');
    };

    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n]);

  const handleChangeLanguage = (language) => {
    i18n.changeLanguage(language).then(() => {
      setLang(language === 'en');
    });
  };

  return (
    <div className="TopBar">
      <div className="TopBar__inner">
        {deviceWidth < 1024 &&
          <Hamburger isOpen={isOpen} closeMenu={closeMenu} />
        }
        {deviceWidth >= 1024 &&
          <div className="TopBar-left" ref={containerRef}>
            <div className='TopBar-dropdown' onMouseEnter={handleMouseEnter1}
              onMouseLeave={handleMouseLeave1}>  <NavLink to="/who-we-are" className={getClassName}  >
                <p >{t('TopBar1')}
                  <span ref={underlineRef} style={{
                    marginTop: '1px',
                    height: '1px',
                    backgroundColor: 'black',
                    display: 'block',
                    width: '100%', // Full width but scaleX will control the animation
                    transform: 'scaleX(0)' // Start with underline hidden
                  }} />
                </p>
              </NavLink>
              {isHovering1 &&
                <div className="TopBar-left-element-menu" onMouseEnter={handleMouseEnter1}
                  onMouseLeave={handleMouseLeave1} >
                  <Link to="/who-we-are#aboutUs" className='TopBar-left-element'>
                    <p>
                      {t('TopBar11')}
                      <span ref={underlineRef} style={{
                        marginTop: '1px',
                        height: '1px',
                        backgroundColor: 'black',
                        display: 'block',
                        width: '100%', // Full width but scaleX will control the animation
                        transform: 'scaleX(0)' // Start with underline hidden
                      }} />
                    </p>
                  </Link>
                  <Link to="/who-we-are#mv" className='TopBar-left-element'>
                    <p>
                    {t('TopBar12')}
                      <span ref={underlineRef} style={{
                        marginTop: '1px',
                        height: '1px',
                        backgroundColor: 'black',
                        display: 'block',
                        width: '100%', // Full width but scaleX will control the animation
                        transform: 'scaleX(0)' // Start with underline hidden
                      }} />
                    </p>
                  </Link>
                  <Link to="/who-we-are#aze" className='TopBar-left-element'>
                    <p>
                    {t('TopBar14')}
                      <span ref={underlineRef} style={{
                        marginTop: '1px',
                        height: '1px',
                        backgroundColor: 'black',
                        display: 'block',
                        width: '100%', // Full width but scaleX will control the animation
                        transform: 'scaleX(0)' // Start with underline hidden
                      }} />
                    </p>
                  </Link>
                </div>
              }</div><div className='TopBar-dropdown' onMouseEnter={handleMouseEnter2}
                onMouseLeave={handleMouseLeave2}>
              <NavLink to="/what-we-offer" className={getClassName}>
                <p>{t('TopBar2')}
                  <span ref={underlineRef} style={{
                    marginTop: '1px',
                    height: '1px',
                    backgroundColor: 'black',
                    display: 'block',
                    width: '100%', // Full width but scaleX will control the animation
                    transform: 'scaleX(0)' // Start with underline hidden
                  }} />
                </p>
              </NavLink>
              {isHovering2 &&
                <div className="TopBar-left-element-menu" onMouseEnter={handleMouseEnter2}
                  onMouseLeave={handleMouseLeave2} >
                  <Link to="/what-we-offer" state={{ re: false }} className='TopBar-left-element'>
                    <p>
                    {t('TopBar21')}
                      <span ref={underlineRef} style={{
                        marginTop: '1px',
                        height: '1px',
                        backgroundColor: 'black',
                        display: 'block',
                        width: '100%', // Full width but scaleX will control the animation
                        transform: 'scaleX(0)' // Start with underline hidden
                      }} />
                    </p>
                  </Link>
                  <Link to="/what-we-offer" state={{ re: true }} className='TopBar-left-element'>
                    <p>
                    {t('TopBar22')}
                      <span ref={underlineRef} style={{
                        marginTop: '1px',
                        height: '1px',
                        backgroundColor: 'black',
                        display: 'block',
                        width: '100%', // Full width but scaleX will control the animation
                        transform: 'scaleX(0)' // Start with underline hidden
                      }} />
                    </p>
                  </Link>
                </div>
              }</div>
            <NavLink to="/news" className={getClassName}>
              <p>{t('TopBar3')}
                <span ref={underlineRef} style={{
                  marginTop: '1px',
                  height: '1px',
                  backgroundColor: 'black',
                  display: 'block',
                  width: '100%', // Full width but scaleX will control the animation
                  transform: 'scaleX(0)' // Start with underline hidden
                }} />
              </p>
            </NavLink>
          </div>}
        <div className="TopBar-center">
          <Link style={{ position: 'absolute', zIndex: '2' }} to="/">
            <img alt="Khamsa Insurance and Reinsurance Brokers" style={{ width: '148px', height: '58px' }} src={L} /></Link>
          {/*<img alt="" src={LogoLeft} className="TopBar-center-left"/>
            <img alt="" src={LogoRight} className="TopBar-center-right"/>*/}
        </div>
        {/* {deviceWidth > 1023 && */}
        <div className="TopBar-right-container">
          <div className="TopBar-right-lang">
            <p ref={AZRef} className="TopBar-right-lang-text" onClick={() => handleChangeLanguage('az')} >AZ</p>
            <div className="TopBar-right-lang-line" />
            <p ref={ENGRef} className="TopBar-right-lang-text2" onClick={() => handleChangeLanguage('en')}>ENG</p>
          </div>
          <Link to='/contact'>  
            <div className="TopBar-right">
              <p className="TopBar-right-text">{t('TopBar4')}</p>
            </div>
          </Link>

          <div onClick={toggleMenu} className="TopBar-hamburger">
            <div className="TopBar-hamburger-center">
              <img alt="" src={H} />
            </div>
          </div>
        </div>
        {/* } */}
        {/* {(deviceWidth > 767 && deviceWidth < 1024) &&

          <div className="TopBar-righTablet">
            <div className="TopBar-right">
              <p className="TopBar-right-text">Contact Us</p>
            </div>
            <div onClick={toggleMenu} className="TopBar-hamburger">
              <div className="TopBar-hamburger-center">
                <img alt="" src={H} />
              </div>
            </div>
          </div>
        } */}
        {/* {deviceWidth <= 767 &&
          <div onClick={toggleMenu} className="TopBar-hamburger">
            <div className="TopBar-hamburger-center">
              <img alt="" src={H} />
            </div>
          </div>
        } */}
      </div>
    </div>
  )
}

export default TopBar